export const nightingalePageConfig = {
  title: 'Realtime Users',
  titleCN: '实时用户',
  subTitle: 'Timezone (UTC{{timeZone}})',
  subTitleCN: '时区 (UTC{{timeZone}})',
  path: '/realtime/users',
  defaultTab: 'users',
  tabList: [
    {
      id: 'users',
      tabName: 'Users',
      tabNameCN: '用户',
      isHaveNotification: true,
      refresh: true,
      notificationPath: '/realtime/users',
      path: '/realtime/users',
      tabIcon: '',
      logConfig: {
        pageId: '200501',
        pageName: 'realtimeRealtimeUsersUsers',
        extInfo: 'realtimeRealtimeUsersUsers',
        pagePath: '/realtime/users',
      },
      filters: [
        {
          name: 'realtimeUserFilter',
          isOpenSticky: false,
          isHaveFilterSave: true,
          filterPath: '/realtime/users',
          componentList: [
            {
              name: 'realtimeUserService',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/realtime/usertag',
                  dataKey: 'usertag',
                  isDark: true,
                  refreshKey: 'realtime_user_usertag',
                  interval: 300000
                }
              },
              children: [
                {
                  name: 'realtimeUserService',
                  className: '',
                  type: 'view',
                  style: {},
                  props: {
                    config: {
                      api: '/api/v1/dashboard/pc/realtime/retention',
                      dataKey: 'retention',
                      isDark: true,
                      refreshKey: 'realtime_user_retention',
                      interval: 300000
                    }
                  },
                  children: [
                    {
                      name: 'realtimeUserService',
                      className: '',
                      type: 'view',
                      style: {},
                      props: {
                        config: {
                          api: '/api/v1/dashboard/event_analysis/realtime/date_event_list',
                          dataKey: 'date_event_list',
                          isDark: true,
                          refreshKey: 'realtime_user_event',
                          interval: 300000
                        }
                      },
                      children: [
                        {
                          name: "MetricsCardTitle",
                          className: "",
                          type: "view",
                          style: {},
                          props: {
                            config: {
                              titleEn: 'Realtime Key Metrics',
                              titleCn: '实时关键指标',
                            }
                          }
                        },
                        {
                          name: 'MetricCardCo',
                          className: 'dbd-retention-card',
                          type: 'view',
                          style: {},
                          props: {
                            config: {}
                          },
                          children: [
                            {
                              name: 'CommonRow',
                              className: '',
                              type: 'layout',
                              style: {},
                              props: {},
                              children: [
                                {
                                  name: 'CommonCol',
                                  className: '',
                                  type: 'layout',
                                  style: {},
                                  children: [
                                    {
                                      name: 'MetricsCardContext',
                                      className: '',
                                      type: 'view',
                                      style: {},
                                      props: {
                                        config: {
                                          apiDataKey: ['usertag'],
                                          dataKey: [
                                            "new_users_card",
                                            "active_users_card",
                                            "online_users_card",
                                          ],
                                          isRealTime: true,
                                        },
                                      },
                                      children: [
                                        {
                                          name: 'CommonRow',
                                          className: '',
                                          type: 'layout',
                                          style: {},
                                          props: {},
                                          children: [
                                            {
                                              name: 'CommonCol',
                                              className: '',
                                              type: 'layout',
                                              style: {},
                                              props: { w: 8 },
                                              children: [
                                                {
                                                  name: 'MetricCard',
                                                  className: '',
                                                  style: {},
                                                  type: 'view',
                                                  props: {
                                                    config: {
                                                      componentMetrics: [{
                                                        metricKey: 'new_users_card',
                                                        enName: 'New Users',
                                                        cnName: '新进用户',
                                                        rangeEnName: 'New Users',
                                                        rangeCnName: '新进用户',
                                                        preUnit: '',
                                                        endUnit: '',
                                                        rainbowKey: 'Pc Metrics New Users',
                                                        type: 'int',
                                                        decimal: 0,
                                                        icon: '',
                                                        position: '',
                                                      }]
                                                    },
                                                    isShowIcon: false
                                                  },
                                                  children: []
                                                },
                                              ]
                                            },
                                            {
                                              name: 'CommonCol',
                                              className: '',
                                              type: 'layout',
                                              style: {},
                                              props: { w: 8 },
                                              children: [
                                                {
                                                  name: 'MetricCard',
                                                  className: '',
                                                  style: {},
                                                  type: 'view',
                                                  props: {
                                                    config: {
                                                      componentMetrics: [{
                                                        metricKey: 'active_users_card',
                                                        enName: 'Active Users',
                                                        cnName: '活跃用户',
                                                        rangeEnName: 'Active Users',
                                                        rangeCnName: '活跃用户',
                                                        preUnit: '',
                                                        endUnit: '',
                                                        rainbowKey: 'Pc Metrics Active Users',
                                                        type: 'int',
                                                        decimal: 0,
                                                        icon: '',
                                                        position: '',
                                                      }]
                                                    }
                                                  },
                                                  children: []
                                                },
                                              ]
                                            },
                                            {
                                              name: 'CommonCol',
                                              className: '',
                                              type: 'layout',
                                              style: {},
                                              props: { w: 8 },
                                              children: [
                                                {
                                                  name: 'MetricCard',
                                                  className: '',
                                                  style: {},
                                                  type: 'view',
                                                  props: {
                                                    config: {
                                                      componentMetrics: [{
                                                        metricKey: 'online_users_card',
                                                        enName: 'Concurrent Users',
                                                        cnName: '在线用户',
                                                        rangeEnName: 'Concurrent Users',
                                                        rangeCnName: '在线用户',
                                                        preUnit: '',
                                                        endUnit: '',
                                                        rainbowKey: 'Pc Metrics Online Users',
                                                        type: 'int',
                                                        decimal: 0,
                                                        icon: '',
                                                        position: '',
                                                      }]
                                                    }
                                                  },
                                                  children: []
                                                },
                                              ]
                                            },
                                          ]
                                        },
                                      ]
                                    },
                                  ]
                                },
                                {
                                  name: 'CommonCol',
                                  className: '',
                                  type: 'layout',
                                  style: {},
                                  children: [
                                    {
                                      name: 'MetricsCardContext',
                                      className: '',
                                      type: 'view',
                                      style: {},
                                      props: {
                                        config: {
                                          apiDataKey: 'retention',
                                          dataKey: [
                                            "d2_card",
                                            "d3_card",
                                            "d7_card",
                                          ],
                                          isRealTime: true,
                                        },
                                      },
                                      children: [
                                        {
                                          name: 'CommonRow',
                                          className: '',
                                          type: 'layout',
                                          style: {},
                                          props: {},
                                          children: [
                                            {
                                              name: 'CommonCol',
                                              className: '',
                                              type: 'layout',
                                              style: {},
                                              props: { w: 8 },
                                              children: [
                                                {
                                                  name: 'MetricCard',
                                                  className: '',
                                                  style: {},
                                                  type: 'view',
                                                  props: {
                                                    config: {
                                                      componentMetrics: [{
                                                        metricKey: 'd2_card',
                                                        enName: 'D1(T-1)',
                                                        cnName: '新进次留（T-1)',
                                                        rangeEnName: 'D1(T-1)',
                                                        rangeCnName: '新进次留（T-1)',
                                                        preUnit: '',
                                                        endUnit: '',
                                                        rainbowKey: 'Pc Metrics D1(T-1)',
                                                        type: 'percent',
                                                        decimal: 2,
                                                        icon: '',
                                                        position: '',
                                                      }]
                                                    },
                                                    isShowIcon: false,
                                                  },
                                                  children: []
                                                },
                                              ]
                                            },
                                            {
                                              name: 'CommonCol',
                                              className: '',
                                              type: 'layout',
                                              style: {},
                                              props: { w: 8 },
                                              children: [
                                                {
                                                  name: 'MetricCard',
                                                  className: '',
                                                  style: {},
                                                  type: 'view',
                                                  props: {
                                                    config: {
                                                      componentMetrics: [{
                                                        metricKey: 'd3_card',
                                                        enName: 'D2(T-2)',
                                                        cnName: '新进2留（T-2)',
                                                        rangeEnName: 'D2(T-2)',
                                                        rangeCnName: '新进2留（T-2)',
                                                        preUnit: '',
                                                        endUnit: '',
                                                        rainbowKey: 'Pc Metrics D2(T-2)',
                                                        type: 'percent',
                                                        decimal: 2,
                                                        icon: '',
                                                        position: '',
                                                      }]
                                                    },
                                                    isShowIcon: false,
                                                  },
                                                  children: []
                                                },
                                              ]
                                            },
                                            {
                                              name: 'CommonCol',
                                              className: '',
                                              type: 'layout',
                                              style: {},
                                              props: { w: 8 },
                                              children: [
                                                {
                                                  name: 'MetricCard',
                                                  className: '',
                                                  style: {},
                                                  type: 'view',
                                                  props: {
                                                    config: {
                                                      componentMetrics: [{
                                                        metricKey: 'd7_card',
                                                        enName: 'D7(T-7)',
                                                        cnName: '新进7留(T-7)',
                                                        rangeEnName: 'D7(T-7)',
                                                        rangeCnName: '新进7留(T-7)',
                                                        preUnit: '',
                                                        endUnit: '',
                                                        rainbowKey: 'Pc Metrics D7(T-7)',
                                                        type: 'percent',
                                                        decimal: 2,
                                                        icon: '',
                                                        position: '',
                                                      }]
                                                    },
                                                    isShowIcon: false,
                                                  },
                                                  children: []
                                                },
                                              ]
                                            },
                                          ]
                                        },
                                      ]
                                    },
                                  ]
                                }
                              ]
                            },
                          ]
                        },
                        {
                          name: 'SegmentScrollCo',
                          className: 'margin-t-20',
                          style: {},
                          type: 'view',
                          props: {
                            config: {
                              componentSegment: [
                                {
                                  value: '1',
                                  enName: 'New',
                                  cnName: '新进用户',
                                  disable: false,
                                  rainbowKey: '',
                                  enTooltip: '',
                                  cntooltip: '',
                                },
                                {
                                  value: '2',
                                  enName: 'Active',
                                  cnName: '活跃用户',
                                  rainbowKey: '',
                                  disable: false,
                                  enTooltip: '',
                                  cntooltip: '',
                                },
                                {
                                  value: '3',
                                  enName: 'Concurrent',
                                  cnName: '在线用户',
                                  rainbowKey: '',
                                  disable: false,
                                  enTooltip: '',
                                  cntooltip: '',
                                },
                                {
                                  value: '4',
                                  enName: 'Retention D2',
                                  cnName: '新进次留（T-1）',
                                  rainbowKey: '',
                                  disable: false,
                                  enTooltip: '',
                                  cntooltip: '',
                                },
                                {
                                  value: '5',
                                  enName: 'Retention D3',
                                  cnName: '新进2留（T-2）',
                                  rainbowKey: '',
                                  disable: false,
                                  enTooltip: '',
                                  cntooltip: '',
                                },
                                {
                                  value: '6',
                                  enName: 'Retention D7',
                                  cnName: '新进7留（T-6）',
                                  rainbowKey: '',
                                  disable: false,
                                  enTooltip: '',
                                  cntooltip: '',
                                },
                              ],
                              scrollMarginTop: '75px' // 滚动偏移配置
                            }
                          },
                          children: [{
                            name: 'RealtimeRentationContext',
                            props: {
                              config: {
                                title: 'Realtime Daily Accumulated New Users (5 min)',
                                titleCn: '新进用户',
                                formatTitle: 'realtime_users_new_title',
                                apiDataKey: 'usertag',
                                dataKey: 'new_users',
                                dataType: '',
                                table: {
                                  option: [{
                                    key: 'time',
                                    align: 'left',
                                    fixed: 'left',
                                    width: 100,
                                    title: 'Time',
                                    titleCn: '时间',
                                    formatTitle: 'realtime_by_country_table_time',
                                    valueKey: 'time'
                                  }, {
                                    key: 'line_dot',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                    titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}',
                                    valueKey: 'lineDot',
                                    format: '#,##0',
                                    type: 'number'
                                  }, {
                                    key: 'line_dot_last',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    valueKey: 'lineDotLast',
                                    format: '#,##0',
                                    type: 'number'
                                  }, {
                                    key: 'line_dot_contrast',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day',
                                    titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日',
                                    valueKey: 'lineDotContrast',
                                    changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                                    changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}',
                                    format: '#,##0',
                                    type: 'number'
                                  }],
                                  sort: true,
                                  columns: ['time'],
                                  defaultValue: [{ by: 'time', order: 'desc' }],
                                  isRealTime: true,
                                  height: 400
                                },
                                subTitle: [{
                                  title: 'DoD',
                                  titleCn: '日环比',
                                  formatTitle: '',
                                  valueKey: 'dod',
                                  unit: 'percent',
                                  bold: true
                                }, {
                                  title: 'SDLW',
                                  titleCn: '上周同期',
                                  formatTitle: '',
                                  valueKey: 'sdlw',
                                  unit: 'percent',
                                  bold: true
                                }],
                                event: {
                                  show: true,
                                  link: 'eventAnalysis/eventDetails',
                                  dataKey: 'date_event_list',
                                  valueKey: 'new_users',
                                  timeType: 'Hour',
                                  cssStyle: { top: '82%' }
                                },
                                chart: {
                                  type: 'line',
                                  series: [{
                                    valueKey: 'line_dot',
                                    title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                    titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}'
                                  }, {
                                    valueKey: 'line_dot_last',
                                    title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                  }, {
                                    valueKey: 'line_dot_contrast',
                                    title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)',
                                    titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)',
                                    changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                                    changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}',
                                  }],
                                  tooltip: {
                                    title: 'New Users',
                                    titleCn: '新进用户',
                                    formatTitle: 'realtime_users_new_users_card_title'
                                  }
                                },
                                download: {
                                  fileName: 'Realtime Daily Accumulated New Users (5 min)',
                                  fileNameCn: '新进用户',
                                  formatFileName: 'realtime_users_new_title',
                                  default: '5',
                                  title: 'Time',
                                  titleCn: '时间粒度',
                                  formatTitle: 'realtime_info_download_time',
                                  type: [
                                    {
                                      title: 'By hour',
                                      titleCn: '下载逐小时数据',
                                      formatTitle: 'realtime_info_download_by_hour',
                                      name: '60',
                                      disable: 'l1h',
                                      beforeDownload: 'hourDownload'
                                    },
                                    {
                                      title: 'By 5 min',
                                      titleCn: '下载每5 min数据',
                                      formatTitle: 'realtime_info_download_by_5_min',
                                      name: '5',
                                      beforeDownload: ''
                                    }
                                  ],
                                  sorting: false,
                                  sort: 'desc'
                                }
                              }
                            },
                            id: 1
                          }, {
                            name: 'RealtimeRentationContext',
                            props: {
                              config: {
                                title: 'Realtime Daily Accumulated Active Users (5 min)',
                                titleCn: '活跃用户',
                                formatTitle: 'realtime_users_active_users_card_title',
                                apiDataKey: 'usertag',
                                dataKey: 'active_users',
                                dataType: '',
                                table: {
                                  option: [{
                                    key: 'time',
                                    align: 'left',
                                    fixed: 'left',
                                    width: 100,
                                    title: 'Time',
                                    titleCn: '时间',
                                    formatTitle: 'realtime_by_country_table_time',
                                    valueKey: 'time'
                                  }, {
                                    key: 'line_dot',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                    titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}',
                                    valueKey: 'lineDot',
                                    format: '#,##0',
                                    type: 'number'
                                  }, {
                                    key: 'line_dot_last',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    valueKey: 'lineDotLast',
                                    format: '#,##0',
                                    type: 'number'
                                  }, {
                                    key: 'line_dot_contrast',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day',
                                    titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日',
                                    valueKey: 'lineDotContrast',
                                    changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                                    changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}',
                                    format: '#,##0',
                                    type: 'number'
                                  }],
                                  sort: true,
                                  columns: ['time'],
                                  defaultValue: [{ by: 'time', order: 'desc' }],
                                  isRealTime: true,
                                  height: 400
                                },
                                subTitle: [{
                                  title: 'DoD',
                                  titleCn: '日环比',
                                  formatTitle: '',
                                  valueKey: 'dod',
                                  unit: 'percent',
                                  bold: true
                                }, {
                                  title: 'SDLW',
                                  titleCn: '上周同期',
                                  formatTitle: '',
                                  valueKey: 'sdlw',
                                  unit: 'percent',
                                  bold: true
                                }],
                                event: {
                                  show: true,
                                  link: 'eventAnalysis/eventDetails',
                                  dataKey: 'date_event_list',
                                  valueKey: 'active_users',
                                  timeType: 'Hour',
                                  cssStyle: { top: '82%' }
                                },
                                chart: {
                                  type: 'line',
                                  series: [{
                                    valueKey: 'line_dot',
                                    title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                    titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}'
                                  }, {
                                    valueKey: 'line_dot_last',
                                    title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',

                                  }, {
                                    valueKey: 'line_dot_contrast',
                                    title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)',
                                    titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)',
                                    changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                                    changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}',
                                  }],
                                  tooltip: {
                                    title: 'Active Users',
                                    titleCn: '活跃用户',
                                    formatTitle: 'realtime_users_active_users_card_title'
                                  }
                                },
                                download: {
                                  fileName: 'Realtime Daily Accumulated Active Users (5 min)',
                                  fileNameCn: '活跃用户',
                                  formatFileName: 'realtime_users_active_users_card_title',
                                  default: '5',
                                  title: 'Time',
                                  titleCn: '时间粒度',
                                  formatTitle: 'realtime_info_download_time',
                                  type: [
                                    {
                                      title: 'By hour',
                                      titleCn: '下载逐小时数据',
                                      formatTitle: 'realtime_info_download_by_hour',
                                      name: '60',
                                      disable: 'l1h',
                                      beforeDownload: 'hourDownload'
                                    },
                                    {
                                      title: 'By 5 min',
                                      titleCn: '下载每5 min数据',
                                      formatTitle: 'realtime_info_download_by_5_min',
                                      name: '5',
                                      beforeDownload: ''
                                    }
                                  ],
                                  sorting: false,
                                  sort: 'desc'
                                }
                              }
                            },
                            id: 2
                          }, {
                            name: 'RealtimeRentationContext',
                            props: {
                              config: {
                                title: 'Realtime Concurrent Users (5 min)',
                                titleCn: '在线用户',
                                formatTitle: 'realtime_users_online_users_card_title',
                                apiDataKey: 'usertag',
                                dataKey: 'online_users',
                                dataType: '',
                                table: {
                                  option: [{
                                    key: 'time',
                                    align: 'left',
                                    fixed: 'left',
                                    width: 100,
                                    title: 'Time',
                                    titleCn: '时间',
                                    formatTitle: 'realtime_by_country_table_time',
                                    valueKey: 'time'
                                  }, {
                                    key: 'line_dot',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                    titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}',
                                    valueKey: 'lineDot',
                                    format: '#,##0',
                                    type: 'number'
                                  }, {
                                    key: 'line_dot_last',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    valueKey: 'lineDotLast',
                                    format: '#,##0',
                                    type: 'number'
                                  }, {
                                    key: 'line_dot_contrast',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day',
                                    titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日',
                                    valueKey: 'lineDotContrast',
                                    changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                                    changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}',
                                    format: '#,##0',
                                    type: 'number'
                                  }],
                                  sort: true,
                                  columns: ['time'],
                                  defaultValue: [{ by: 'time', order: 'desc' }],
                                  isRealTime: true,
                                  height: 400
                                },
                                subTitle: [{
                                  title: 'DoD',
                                  titleCn: '日环比',
                                  formatTitle: '',
                                  valueKey: 'dod',
                                  unit: 'percent',
                                  bold: true
                                }, {
                                  title: 'SDLW',
                                  titleCn: '上周同期',
                                  formatTitle: '',
                                  valueKey: 'sdlw',
                                  unit: 'percent',
                                  bold: true
                                }],
                                event: {
                                  show: true,
                                  link: 'eventAnalysis/eventDetails',
                                  dataKey: 'date_event_list',
                                  valueKey: 'online_users',
                                  timeType: 'Hour',
                                  cssStyle: { top: '82%' }
                                },
                                chart: {
                                  type: 'line',
                                  series: [{
                                    valueKey: 'line_dot',
                                    title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                    titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}'
                                  }, {
                                    valueKey: 'line_dot_last',
                                    title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',

                                  }, {
                                    valueKey: 'line_dot_contrast',
                                    title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)',
                                    titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)',
                                    changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                                    changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}',
                                  }],
                                  tooltip: {
                                    title: 'Concurrent Users',
                                    titleCn: '在线用户',
                                    formatTitle: 'realtime_users_online_users_card_title'
                                  }
                                },
                                download: {
                                  fileName: 'Realtime Concurrent Users (5 min)',
                                  fileNameCn: '在线用户',
                                  formatFileName: 'realtime_users_online_users_card_title',
                                  default: '5',
                                  title: 'Time',
                                  titleCn: '时间粒度',
                                  formatTitle: 'realtime_info_download_time',
                                  type: [
                                    {
                                      title: 'By hour',
                                      titleCn: '下载逐小时数据',
                                      formatTitle: 'realtime_info_download_by_hour',
                                      name: '60',
                                      disable: 'l1h',
                                      beforeDownload: 'hourDownload'
                                    },
                                    {
                                      title: 'By 5 min',
                                      titleCn: '下载每5 min数据',
                                      formatTitle: 'realtime_info_download_by_5_min',
                                      name: '5',
                                      beforeDownload: ''
                                    }
                                  ],
                                  sorting: false,
                                  sort: 'desc'
                                }
                              }
                            },
                            id: 3
                          }, {
                            name: 'RealtimeRentationContext',
                            props: {
                              config: {
                                title: 'Retention D1 (1 hour)',
                                titleCn: '新进次留(T-1)',
                                formatTitle: 'realtime_users_d2_title_pc',
                                apiDataKey: 'retention',
                                dataKey: 'd2',
                                dataType: 'percent',
                                table: {
                                  option: [{
                                    key: 'time',
                                    align: 'left',
                                    fixed: 'left',
                                    width: 100,
                                    title: 'Time',
                                    titleCn: '时间',
                                    formatTitle: 'realtime_by_country_table_time',
                                    valueKey: 'time'
                                  }, {
                                    key: 'line_dot',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                    titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}',
                                    valueKey: 'lineDot'
                                  }, {
                                    key: 'line_dot_last',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    valueKey: 'lineDotLast'
                                  }, {
                                    key: 'line_dot_contrast',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day',
                                    titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日',
                                    valueKey: 'lineDotContrast',
                                    changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                                    changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}'
                                  }],
                                  sort: true,
                                  columns: ['time'],
                                  defaultValue: [{ by: 'time', order: 'desc' }],
                                  isRealTime: true,
                                  height: 400
                                },
                                subTitle: [{
                                  title: 'DoD',
                                  titleCn: '日环比',
                                  formatTitle: '',
                                  valueKey: 'dod',
                                  unit: 'percent',
                                  bold: true
                                }, {
                                  title: 'SDLW',
                                  titleCn: '上周同期',
                                  formatTitle: '',
                                  valueKey: 'sdlw',
                                  unit: 'percent',
                                  bold: true
                                }, {
                                  title: 'Register Date',
                                  titleCn: '注册日期',
                                  formatTitle: '',
                                  valueKey: 'reg_date',
                                  unit: 'date',
                                  bold: false
                                }, {
                                  title: 'Total New',
                                  titleCn: '新进总数',
                                  formatTitle: '',
                                  valueKey: 'total_new',
                                  unit: 'number',
                                  bold: false
                                }],
                                chart: {
                                  type: 'line',
                                  series: [{
                                    valueKey: 'line_dot',
                                    title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                    titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}'
                                  }, {
                                    valueKey: 'line_dot_last',
                                    title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',

                                  }, {
                                    valueKey: 'line_dot_contrast',
                                    title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)',
                                    titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)',
                                    changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                                    changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}',
                                  }],
                                  tooltip: {
                                    title: 'D1(T-1)',
                                    titleCn: '新进次留(T-1)',
                                    formatTitle: 'realtime_users_d2_card_title_pc'
                                  }
                                }
                              }
                            },
                            id: 4
                          }, {
                            name: 'RealtimeRentationContext',
                            props: {
                              config: {
                                title: 'Retention D2 (1 hour)',
                                titleCn: '新进2留(T-2)',
                                formatTitle: 'realtime_users_d3_title_pc',
                                apiDataKey: 'retention',
                                dataKey: 'd3',
                                dataType: 'percent',
                                table: {
                                  option: [{
                                    key: 'time',
                                    align: 'left',
                                    fixed: 'left',
                                    width: 100,
                                    title: 'Time',
                                    titleCn: '时间',
                                    formatTitle: 'realtime_by_country_table_time',
                                    valueKey: 'time'
                                  }, {
                                    key: 'line_dot',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                    titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}',
                                    valueKey: 'lineDot'
                                  }, {
                                    key: 'line_dot_last',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    valueKey: 'lineDotLast'
                                  }, {
                                    key: 'line_dot_contrast',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day',
                                    titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日',
                                    valueKey: 'lineDotContrast',
                                    changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                                    changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}'
                                  }],
                                  sort: true,
                                  columns: ['time'],
                                  defaultValue: [{ by: 'time', order: 'desc' }],
                                  isRealTime: true,
                                  height: 400
                                },
                                subTitle: [{
                                  title: 'DoD',
                                  titleCn: '日环比',
                                  formatTitle: '',
                                  valueKey: 'dod',
                                  unit: 'percent',
                                  bold: true
                                }, {
                                  title: 'SDLW',
                                  titleCn: '上周同期',
                                  formatTitle: '',
                                  valueKey: 'sdlw',
                                  unit: 'percent',
                                  bold: true
                                }, {
                                  title: 'Register Date',
                                  titleCn: '注册日期',
                                  formatTitle: '',
                                  valueKey: 'reg_date',
                                  unit: 'date',
                                  bold: false
                                }, {
                                  title: 'Total New',
                                  titleCn: '新进总数',
                                  formatTitle: '',
                                  valueKey: 'total_new',
                                  unit: 'number',
                                  bold: false
                                }],
                                chart: {
                                  type: 'line',
                                  series: [{
                                    valueKey: 'line_dot',
                                    title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                    titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}'
                                  }, {
                                    valueKey: 'line_dot_last',
                                    title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',

                                  }, {
                                    valueKey: 'line_dot_last',
                                    title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)',
                                    titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)',
                                    changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                                    changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}',
                                  }],
                                  tooltip: {
                                    title: 'D2(T-2)',
                                    titleCn: '新进次留(T-2)',
                                    formatTitle: 'realtime_users_d3_card_title_pc'
                                  }
                                }
                              }
                            },
                            id: 5
                          }, {
                            name: 'RealtimeRentationContext',
                            props: {
                              config: {
                                title: 'Retention D7 (1 hour)',
                                titleCn: '新进7留(T-7)',
                                formatTitle: 'realtime_users_d7_title_pc',
                                apiDataKey: 'retention',
                                dataKey: 'd7',
                                dataType: 'percent',
                                table: {
                                  option: [{
                                    key: 'time',
                                    align: 'left',
                                    fixed: 'left',
                                    width: 100,
                                    title: 'Time',
                                    titleCn: '时间',
                                    formatTitle: 'realtime_by_country_table_time',
                                    valueKey: 'time'
                                  }, {
                                    key: 'line_dot',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                    titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}',
                                    valueKey: 'lineDot'
                                  }, {
                                    key: 'line_dot_last',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    valueKey: 'lineDotLast'
                                  }, {
                                    key: 'line_dot_contrast',
                                    align: 'right',
                                    fixed: '',
                                    width: 100,
                                    title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day',
                                    titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日',
                                    valueKey: 'lineDotContrast',
                                    changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                                    changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}'
                                  }],
                                  sort: true,
                                  columns: ['time'],
                                  defaultValue: [{ by: 'time', order: 'desc' }],
                                  isRealTime: true,
                                  height: 400
                                },
                                subTitle: [{
                                  title: 'DoD',
                                  titleCn: '日环比',
                                  formatTitle: '',
                                  valueKey: 'dod',
                                  unit: 'percent',
                                  bold: true
                                }, {
                                  title: 'SDLW',
                                  titleCn: '上周同期',
                                  formatTitle: '',
                                  valueKey: 'sdlw',
                                  unit: 'percent',
                                  bold: true
                                }, {
                                  title: 'Register Date',
                                  titleCn: '注册日期',
                                  formatTitle: '',
                                  valueKey: 'reg_date',
                                  unit: 'date',
                                  bold: false
                                }, {
                                  title: 'Total New',
                                  titleCn: '新进总数',
                                  formatTitle: '',
                                  valueKey: 'total_new',
                                  unit: 'number',
                                  bold: false
                                }],
                                chart: {
                                  type: 'line',
                                  series: [{
                                    valueKey: 'line_dot',
                                    title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                    titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}'
                                  }, {
                                    valueKey: 'line_dot_last',
                                    title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                    titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',

                                  }, {
                                    valueKey: 'line_dot_last',
                                    title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)',
                                    titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)',
                                    changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                                    changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}',
                                  }],
                                  tooltip: {
                                    title: 'D7(T-6)',
                                    titleCn: '新进7留(T-7)',
                                    formatTitle: 'realtime_users_d7_card_title_pc'
                                  }
                                }
                              }
                            },
                            id: 6
                          }]
                        },
                      ]
                    }
                  ]
                }
              ]
            },
          ]
        },
      ],
    },
    {
      id: 'byCountryRegionZone',
      tabName: 'By country/region/zone',
      tabNameCN: '国家/区域/区服',
      isHaveNotification: true,
      refresh: true,
      notificationPath: '/realtime/users/byCountryRegionZone',
      path: '/realtime/users/byCountryRegionZone',
      tabIcon: '',
      logConfig: {
        pageId: '200502',
        pageName: 'realtimeRealtimeUsersByCountryRegionZone',
        extInfo: 'realtimeRealtimeUsersByCountryRegionZone',
        pagePath: '/realtime/users/byCountryRegionZone',
      },
      filters: [
        {
          name: 'realtimeCountryFilter',
          isOpenSticky: false,
          isHaveFilterSave: true,
          filterPath: '/realtime/users/byCountryRegionZone',
          componentList: [
            {
              name: 'realtimeUserService',
              className: 'dbd-daily-card',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/realtime/new_active_online',
                  dataKey: 'country_new_active_online',
                  isDark: true,
                  refreshKey: 'realtime_country_new_active_online',
                  interval: 300000
                }
              },
              data: {
                dataBy: "country"
              },
              children: [
                {
                  name: 'realtimeUserService',
                  className: 'dbd-daily-card',
                  type: 'view',
                  style: {},
                  props: {
                    config: {
                      api: '/api/v1/dashboard/pc/realtime/retention_d237',
                      dataKey: 'country_d237',
                      isDark: true,
                      refreshKey: 'realtime_country_d237',
                      interval: 300000
                    }
                  },
                  children: [
                    {
                      name: 'ScrollBodyCo',
                      className: 'margin-t-20',
                      style: {},
                      type: 'view',
                      props: {
                        config: {
                          dataKey: "dataBy",
                          componentSegment: [
                            {
                              value: '1',
                              enName: 'New',
                              cnName: '新进用户',
                              disable: false,
                              rainbowKey: '',
                              enTooltip: '',
                              cntooltip: '',
                            },
                            {
                              value: '2',
                              enName: 'Active',
                              cnName: '活跃用户',
                              rainbowKey: '',
                              disable: false,
                              enTooltip: '',
                              cntooltip: '',
                            },
                            {
                              value: '3',
                              enName: 'Concurrent',
                              cnName: '在线用户',
                              rainbowKey: '',
                              disable: false,
                              enTooltip: '',
                              cntooltip: '',
                            },
                            {
                              value: '4',
                              enName: 'Retention D1',
                              cnName: '新进次留（T-1）',
                              rainbowKey: '',
                              disable: false,
                              enTooltip: '',
                              cntooltip: '',
                            },
                            {
                              value: '5',
                              enName: 'Retention D2',
                              cnName: '新进2留（T-2）',
                              rainbowKey: '',
                              disable: false,
                              enTooltip: '',
                              cntooltip: '',
                            },
                            {
                              value: '6',
                              enName: 'Retention D7',
                              cnName: '新进7留（T-7）',
                              rainbowKey: '',
                              disable: false,
                              enTooltip: '',
                              cntooltip: '',
                            },
                          ],
                          scrollMarginTop: '75px' // 滚动偏移配置
                        }
                      },
                      children: [
                        {
                          name: 'TrendChartCo',
                          className: '',
                          type: 'view',
                          props: {
                            config: {
                              title: 'Realtime Daily Accumulated New Users (5 min)',
                              titleCn: '新进用户',
                              formatTitle: 'realtime_by_country_new_title',
                              dataKey: 'country_new_active_online',
                              dataType: 'int',
                              metricsCardList: {
                                dataKey: 'new_users_info',
                              },
                              lastTime: {
                                dataKey: 'new_user_last_time',
                              },
                              chart: {
                                dataKey: 'new_users_top',
                                tooltip: {
                                  title: 'New Users',
                                  titleCn: '新进用户',
                                  formatTitle: 'realtime_users_new_users_card_title',
                                  share: true,
                                  shareTitle: 'Share',
                                  shareTitleCn: '占比'
                                },
                              },
                              table: {
                                dataKey: 'new_users_list',
                                options: [
                                  {
                                    key: 'time',
                                    align: 'left',
                                    width: 100,
                                    title: 'Time',
                                    titleCn: '时间',
                                    formatTitle: 'realtime_by_country_table_time',
                                    type: 'date',
                                    format: 'HH:mm',
                                  },
                                  {
                                    key: 'type',
                                    align: 'left',
                                    width: 100,
                                    title: 'table_{{dataBy}}',
                                    titleCn: 'table_{{dataBy}}',
                                    formatTitle: 'realtime_by_country_table_{{dataBy}}',
                                    type: 'string',
                                  },
                                  {
                                    key: 'value',
                                    align: 'right',
                                    width: 100,
                                    title: 'New Users',
                                    titleCn: '新进用户',
                                    formatTitle: 'realtime_by_country_table_new_users',
                                    type: 'number',
                                    format: '#,##0'
                                  },
                                  {
                                    key: 'share',
                                    align: 'right',
                                    width: 100,
                                    title: 'Share',
                                    titleCn: '占比',
                                    formatTitle: '',
                                    type: 'number',
                                    format: '0.0%'
                                  },
                                ]
                              },
                              download: [{
                                title: 'Time',
                                titleCn: '时间粒度',
                                formatTitle: 'realtime_info_download_time',
                                defaultValue: '5',
                                type: [
                                  {
                                    title: 'By hour',
                                    titleCn: '下载逐小时数据',
                                    formatTitle: 'realtime_info_download_by_hour',
                                    value: '60',
                                    disabled: false,
                                  },
                                  {
                                    title: 'By 5 min',
                                    titleCn: '下载每5 min数据',
                                    formatTitle: 'realtime_info_download_by_5_min',
                                    value: '5',
                                    disabled: false,
                                  }
                                ]
                              }]
                            },
                          },
                        },
                        {
                          name: 'TrendChartCo',
                          className: '',
                          type: 'view',
                          props: {
                            config: {
                              title: 'Realtime Daily Accumulated Active Users (5 min)',
                              titleCn: '活跃用户',
                              formatTitle: 'realtime_by_country_active_title',
                              dataKey: 'country_new_active_online',
                              dataType: 'int',
                              metricsCardList: {
                                dataKey: 'active_user_info',
                              },
                              lastTime: {
                                dataKey: 'active_user_last_time',
                              },
                              chart: {
                                dataKey: 'active_users_top',
                                tooltip: {
                                  title: 'Active Users',
                                  titleCn: '活跃用户',
                                  formatTitle: 'realtime_users_active_users_card_title',
                                  share: true,
                                  shareTitle: 'Share',
                                  shareTitleCn: '占比'
                                },
                              },
                              table: {
                                dataKey: 'active_users_list',
                                options: [
                                  {
                                    key: 'time',
                                    align: 'left',
                                    width: 100,
                                    title: 'Time',
                                    titleCn: '时间',
                                    formatTitle: 'realtime_by_country_table_time',
                                    type: 'date',
                                    format: 'HH:mm',
                                  },
                                  {
                                    key: 'type',
                                    align: 'left',
                                    width: 100,
                                    title: 'table_{{dataBy}}',
                                    titleCn: 'table_{{dataBy}}',
                                    formatTitle: 'realtime_by_country_table_{{dataBy}}',
                                    type: 'string',
                                  },
                                  {
                                    key: 'value',
                                    align: 'right',
                                    width: 100,
                                    title: 'Active Users',
                                    titleCn: '活跃用户',
                                    formatTitle: 'realtime_by_country_table_active_users',
                                    type: 'number',
                                    format: '#,##0'
                                  },
                                  {
                                    key: 'share',
                                    align: 'right',
                                    width: 100,
                                    title: 'Share',
                                    titleCn: '占比',
                                    formatTitle: '',
                                    type: 'number',
                                    format: '0.0%'
                                  },
                                ]
                              },
                              download: [{
                                title: 'Time',
                                titleCn: '时间粒度',
                                formatTitle: 'realtime_info_download_time',
                                defaultValue: '5',
                                type: [
                                  {
                                    title: 'By hour',
                                    titleCn: '下载逐小时数据',
                                    formatTitle: 'realtime_info_download_by_hour',
                                    value: '60',
                                    disabled: false,
                                  },
                                  {
                                    title: 'By 5 min',
                                    titleCn: '下载每5 min数据',
                                    formatTitle: 'realtime_info_download_by_5_min',
                                    value: '5',
                                    disabled: false,
                                  }
                                ]
                              }]
                            },
                          },
                        },
                        {
                          name: 'TrendChartCo',
                          className: '',
                          type: 'view',
                          props: {
                            config: {
                              title: 'Realtime Concurrent Users(5 min)',
                              titleCn: '在线用户',
                              formatTitle: 'realtime_by_country_online_title',
                              dataKey: 'country_new_active_online',
                              dataType: 'int',
                              metricsCardList: {
                                dataKey: 'online_user_info',
                              },
                              lastTime: {
                                dataKey: 'online_user_last_time',
                              },
                              chart: {
                                dataKey: 'online_users_top',
                                tooltip: {
                                  title: 'Concurrent Users',
                                  titleCn: '在线用户',
                                  formatTitle: 'realtime_users_online_users_card_title',
                                  share: true,
                                  shareTitle: 'Share',
                                  shareTitleCn: '占比'
                                },
                              },
                              table: {
                                dataKey: 'online_users_list',
                                options: [
                                  {
                                    key: 'time',
                                    align: 'left',
                                    width: 100,
                                    title: 'Time',
                                    titleCn: '时间',
                                    formatTitle: 'realtime_by_country_table_time',
                                    type: 'date',
                                    format: 'HH:mm',
                                  },
                                  {
                                    key: 'type',
                                    align: 'left',
                                    width: 100,
                                    title: 'table_{{dataBy}}',
                                    titleCn: 'table_{{dataBy}}',
                                    formatTitle: 'realtime_by_country_table_{{dataBy}}',
                                    type: 'string',
                                  },
                                  {
                                    key: 'value',
                                    align: 'right',
                                    width: 100,
                                    title: 'Concurrent Users',
                                    titleCn: '在线用户',
                                    formatTitle: 'realtime_by_country_table_online_users',
                                    type: 'number',
                                    format: '#,##0'
                                  },
                                  {
                                    key: 'share',
                                    align: 'right',
                                    width: 100,
                                    title: 'Share',
                                    titleCn: '占比',
                                    formatTitle: '',
                                    type: 'number',
                                    format: '0.0%'
                                  },
                                ]
                              },
                              download: [{
                                title: 'Time',
                                titleCn: '时间粒度',
                                formatTitle: 'realtime_info_download_time',
                                defaultValue: '5',
                                type: [
                                  {
                                    title: 'By hour',
                                    titleCn: '下载逐小时数据',
                                    formatTitle: 'realtime_info_download_by_hour',
                                    value: '60',
                                    disabled: false,
                                  },
                                  {
                                    title: 'By 5 min',
                                    titleCn: '下载每5 min数据',
                                    formatTitle: 'realtime_info_download_by_5_min',
                                    value: '5',
                                    disabled: false,
                                  }
                                ]
                              }]
                            },
                          },
                        },
                        {
                          name: 'TrendChartCo',
                          className: '',
                          type: 'view',
                          props: {
                            config: {
                              title: 'Retention D1 (1 hour)',
                              titleCn: '新进次留(T-1)',
                              formatTitle: 'realtime_by_country_d2_title',
                              dataKey: 'country_d237',
                              dataType: 'percent',
                              metricsCardList: {
                                dataKey: 'd2_info'
                              },
                              lastTime: {
                                dataKey: 'd2_last_time',
                              },
                              registerDate: {
                                dataKey: 'd2_register_date'
                              },
                              chart: {
                                dataKey: 'd2_top',
                                tooltip: {
                                  title: 'D1(T-1)',
                                  titleCn: '新进次留(T-1)',
                                  formatTitle: 'realtime_users_d2_card_title_pc',
                                },
                              },
                              table: {
                                dataKey: 'd2_list',
                                titleFormat: 'countryTableD2',
                                options: [
                                  {
                                    key: 'time',
                                    align: 'left',
                                    width: 100,
                                    title: 'Time',
                                    titleCn: '时间',
                                    formatTitle: 'realtime_by_country_table_time',
                                    type: 'date',
                                    format: 'HH:mm',
                                  },
                                  {
                                    key: 'type',
                                    align: 'center',
                                    width: 100,
                                    title: 'table_{{dataBy}}',
                                    titleCn: 'table_{{dataBy}}',
                                    formatTitle: 'realtime_by_country_table_{{dataBy}}',
                                    type: 'string',
                                  },
                                  {
                                    key: 'new',
                                    align: 'right',
                                    width: 100,
                                    title: 'New Users',
                                    titleCn: '新进用户',
                                    formatTitle: 'realtime_by_country_table_new_users',
                                    type: 'number',
                                    format: '#,##0'
                                  },
                                  {
                                    key: 'value',
                                    align: 'right',
                                    width: 100,
                                    title: 'D1',
                                    titleCn: '次留',
                                    formatTitle: 'realtime_by_country_table_d2',
                                    type: 'number',
                                    format: '0.00%'
                                  },
                                ],
                              },
                            },
                          },
                        },
                        {
                          name: 'TrendChartCo',
                          className: '',
                          type: 'view',
                          props: {
                            config: {
                              title: 'Retention D2 (1 hour)',
                              titleCn: '新进2留(T-2)',
                              formatTitle: 'realtime_by_country_d3_title',
                              dataKey: 'country_d237',
                              dataType: 'percent',
                              metricsCardList: {
                                dataKey: 'd3_info'
                              },
                              lastTime: {
                                dataKey: 'd3_last_time',
                              },
                              registerDate: {
                                dataKey: 'd3_register_date'
                              },
                              chart: {
                                dataKey: 'd3_top',
                                tooltip: {
                                  title: 'D2(T-2)',
                                  titleCn: '新进2留(T-2)',
                                  formatTitle: 'realtime_users_d3_card_title_pc',
                                },
                              },
                              table: {
                                dataKey: 'd3_list',
                                titleFormat: 'countryTableD2',
                                options: [
                                  {
                                    key: 'time',
                                    align: 'left',
                                    width: 100,
                                    title: 'Time',
                                    titleCn: '时间',
                                    formatTitle: 'realtime_by_country_table_time',
                                    type: 'date',
                                    format: 'HH:mm',
                                  },
                                  {
                                    key: 'type',
                                    align: 'center',
                                    width: 100,
                                    title: 'table_{{dataBy}}',
                                    titleCn: 'table_{{dataBy}}',
                                    formatTitle: 'realtime_by_country_table_{{dataBy}}',
                                    type: 'string',
                                  },
                                  {
                                    key: 'new',
                                    align: 'right',
                                    width: 100,
                                    title: 'New Users',
                                    titleCn: '新进用户',
                                    formatTitle: 'realtime_by_country_table_new_users',
                                    type: 'number',
                                    format: '#,##0'
                                  },
                                  {
                                    key: 'value',
                                    align: 'right',
                                    width: 100,
                                    title: 'D2',
                                    titleCn: '2留',
                                    formatTitle: 'realtime_by_country_table_d3',
                                    type: 'number',
                                    format: '0.00%'
                                  },
                                ],
                              },
                            },
                          },
                        },
                        {
                          name: 'TrendChartCo',
                          className: '',
                          type: 'view',
                          props: {
                            config: {
                              title: 'Retention D7 (1 hour)',
                              titleCn: '新进7留(T-7)',
                              formatTitle: 'realtime_by_country_d7_title',
                              dataKey: 'country_d237',
                              dataType: 'percent',
                              metricsCardList: {
                                dataKey: 'd7_info'
                              },
                              lastTime: {
                                dataKey: 'd7_last_time',
                              },
                              registerDate: {
                                dataKey: 'd7_register_date'
                              },
                              chart: {
                                dataKey: 'd7_top',
                                tooltip: {
                                  title: 'D7(T-7)',
                                  titleCn: '新进7留(T-7)',
                                  formatTitle: 'realtime_users_d7_card_title_pc',
                                },
                              },
                              table: {
                                dataKey: 'd7_list',
                                titleFormat: 'countryTableD2',
                                options: [
                                  {
                                    key: 'time',
                                    align: 'left',
                                    width: 100,
                                    title: 'Time',
                                    titleCn: '时间',
                                    formatTitle: 'realtime_by_country_table_time',
                                    type: 'date',
                                    format: 'HH:mm',
                                  },
                                  {
                                    key: 'type',
                                    align: 'center',
                                    width: 100,
                                    title: 'table_{{dataBy}}',
                                    titleCn: 'table_{{dataBy}}',
                                    formatTitle: 'realtime_by_country_table_{{dataBy}}',
                                    type: 'string',
                                  },
                                  {
                                    key: 'new',
                                    align: 'right',
                                    width: 100,
                                    title: 'New Users',
                                    titleCn: '新进用户',
                                    formatTitle: 'realtime_by_country_table_new_users',
                                    type: 'number',
                                    format: '#,##0'
                                  },
                                  {
                                    key: 'value',
                                    align: 'right',
                                    width: 100,
                                    title: 'D7',
                                    titleCn: '7留',
                                    formatTitle: 'realtime_by_country_table_d7',
                                    type: 'number',
                                    format: '0.00%'
                                  },
                                ],
                              },
                            },
                          },
                        },
                      ]
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 'changeAnalysis',
      tabName: 'Change Analysis',
      tabNameCN: '异动分析',
      isHaveNotification: true,
      refresh: true,
      notificationPath: '/realtime/users/changeAnalysis',
      path: '/realtime/users/changeAnalysis',
      tabIcon: '',
      logConfig: {
        pageId: '200503',
        pageName: 'realtimeRealtimeUsersChangeAnalysis',
        extInfo: 'realtimeRealtimeUsersChangeAnalysis',
        pagePath: '/realtime/users/changeAnalysis',
      },
      filters: [
        {
          data: {
            activeTab: 'common',
          },
          name: 'realtimeAnalysisFilter',
          isOpenSticky: false,
          isHaveFilterSave: true,
          filterPath: '/realtime/users/changeAnalysis',
          componentList: [
            {
              name: 'realtimeUserService',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/realtime/change/new_active_online',
                  isDark: true,
                  dataKey: 'analysis_online',
                  refreshKey: 'realtime_analysis_online',
                  interval: 300000
                },
              },
              data: {
                is_key_country: false,
                trend_type: 'same',
                hour: '23:59',
              },
              children: [
                {
                  name: 'realtimeUserService',
                  className: '',
                  type: 'view',
                  style: {},
                  props: {
                    config: {
                      api: '/api/v1/dashboard/pc/realtime/change/retention/d237',
                      isDark: true,
                      dataKey: 'analysis_d237',
                      refreshKey: 'realtime_analysis_d237',
                      interval: 300000
                    }
                  },
                  children: [
                    {
                      name: 'ChangeAnalysisContext',
                      className: 'margin-t-20',
                      style: {},
                      type: 'view',
                      props: {
                        config: {
                          componentSegment: [
                            {
                              value: '1',
                              enName: 'Total',
                              cnName: '汇总',
                              disable: false,
                              rainbowKey: '',
                              enTooltip: '',
                              cntooltip: '',
                              is_key_country: false
                            },
                            {
                              value: '2',
                              enName: 'Key Country/Market',
                              cnName: '关注国家',
                              rainbowKey: '',
                              disable: false,
                              enTooltip: '',
                              cntooltip: '',
                              is_key_country: true
                            },
                          ],
                        }
                      },
                      children: [
                        {
                          name: 'AnalysisTopChangeCard',
                          props: {
                            config: {
                              title: "Top 20 countries by Realtime Daily Accumulated New Users Change (5min)",
                              titleCn: "Top20新进用户变化国家（5min）",
                              formatTitle: "realtime_analysis_Title_1",
                              apiKey: "analysis_online",
                              title2: "New",
                              titleCn2: "新进用户",
                              formatTitle2: "realtime_analysis_D2",
                              data: {
                                key: "new",
                                table: "new_users_info",
                                chart: "new_users_list",
                                time: "new_user_last_time"
                              }
                            }
                          }
                        },
                        {
                          name: 'AnalysisTopChangeCard',
                          props: {
                            config: {
                              title: "Top 20 countries by Realtime Daily Accumulated Active Users Change (5min)",
                              titleCn: "Top20活跃用户变化国家（5min）",
                              formatTitle: "realtime_analysis_Title_2",
                              apiKey: "analysis_online",
                              title2: "Active",
                              titleCn2: "活跃用户",
                              formatTitle2: "realtime_analysis_Active",
                              data: {
                                key: "active",
                                table: "active_user_info",
                                chart: "active_users_list",
                                time: "active_user_last_time"
                              }
                            }
                          }
                        },
                        {
                          name: 'AnalysisTopChangeCard',
                          props: {
                            config: {
                              title: "Top 20 countries by Realtime Concurrent Users Change (5min)",
                              titleCn: "Top20在线用户变化国家（5min）",
                              formatTitle: "realtime_analysis_Title_3",
                              apiKey: "analysis_online",
                              title2: "Concurrent",
                              titleCn2: "在线用户",
                              formatTitle2: "realtime_analysis_Online",
                              data: {
                                key: "online",
                                table: "online_user_info",
                                chart: "online_users_list",
                                time: "online_user_last_time"
                              }
                            }
                          }
                        },
                        {
                          name: 'AnalysisTopChangeCard',
                          props: {
                            config: {
                              title: "Top 20 countries by Retention D2 Change (1 hour)",
                              titleCn: "Top20次留变化国家（1小时）",
                              formatTitle: "realtime_analysis_Title_4",
                              dataKey: "d2",
                              apiKey: "analysis_d237",
                              title2: "D2",
                              titleCn2: "次留",
                              formatTitle2: "realtime_analysis_D2",
                              data: {
                                key: "d2",
                                table: "d2",
                                chart: "d2_list",
                                time: "d2_last_time"
                              }
                            }
                          }
                        },
                        {
                          name: 'AnalysisTopChangeCard',
                          props: {
                            config: {
                              title: "Top 20 countries by Retention D3 Change (1 hour)",
                              titleCn: "Top20三留变化国家（1小时）",
                              formatTitle: "realtime_analysis_Title_5",
                              apiKey: "analysis_d237",
                              title2: "D3",
                              titleCn2: "3留",
                              formatTitle2: "realtime_analysis_D3",
                              data: {
                                key: "d3",
                                table: "d3",
                                chart: "d3_list",
                                time: "d3_last_time"
                              }
                            }
                          }
                        },
                        {
                          name: 'AnalysisTopChangeCard',
                          props: {
                            config: {
                              title: "Top 20 countries by Retention D7 Change (1 hour)",
                              titleCn: "Top20七留变化国家（1小时）",
                              formatTitle: "realtime_analysis_Title_6",
                              apiKey: "analysis_d237",
                              title2: "D7",
                              titleCn2: "7留",
                              formatTitle2: "realtime_analysis_D7",
                              data: {
                                key: "d7",
                                table: "d7",
                                chart: "d7_list",
                                time: "d7_last_time"
                              }
                            }
                          }
                        }
                      ]
                    },
                  ]


                }
              ]
            },
          ]
        },
      ],
    },
    {
      id: 'dataDownload',
      tabName: 'Data Download',
      tabNameCN: '数据下载',
      isHaveNotification: true,
      notificationPath: '/realtime/users/dataDownload',
      path: '/realtime/users/dataDownload',
      tabIcon: '',
      logConfig: {
        pageId: '200504',
        pageName: 'realtimeRealtimeUsersDataDownload',
        extInfo: 'realtimeRealtimeUsersDataDownload',
        pagePath: '/realtime/users/dataDownload',
      },
      filters: [
        {
          name: 'realtimeDownloadFilter',
          isOpenSticky: false,
          isHaveFilterSave: true,
          filterPath: '/realtime/users/dataDownload',
          componentList: [
            {
              name: 'DataDownloadTableCo',
              className: 'margin-t-20',
              type: 'view',
              style: {},
              props: {
                config: {
                  titleEn: 'Users Data Overall Performance',
                  titleCn: '用户数据总体表现',
                  isHaveDiff: false,
                  showStatistic: ['avg'],
                  formatType: 'playtime',
                  slotConfig: {
                    isShowValueType: false,
                    isShowMetricsSettings: false,
                    isShowProgressBar: false,
                    isShowdownloadConfig: false,
                  },
                  api: {
                    tableApi: '/api/v1/dashboard/realtime/overall/userinfo',
                    tableDownloadApi: '/api/v1/dashboard/realtime/overall/userinfo/download',
                  },
                  componentMetrics: [
                    {
                      metricKey: 'acc_new_users',
                      reqMetricKey: 'acc_new_users',
                      enPercentWidth: 185,
                      cnPercentWidth: 185,
                      enWidth: 185,
                      cnWidth: 185,
                      enName: 'NEW',
                      cnName: '新进',
                      rainbowKey: 'Pc Metrics New Users',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },
                    {
                      metricKey: 'acc_active_users',
                      reqMetricKey: 'acc_active_users',
                      enPercentWidth: 185,
                      cnPercentWidth: 185,
                      enWidth: 185,
                      cnWidth: 185,
                      enName: 'DAU',
                      cnName: '日活跃',
                      rainbowKey: 'Pc Metrics Active Users',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },
                    {
                      metricKey: 'onlinecnt',
                      reqMetricKey: 'onlinecnt',
                      enPercentWidth: 185,
                      cnPercentWidth: 185,
                      enWidth: 185,
                      cnWidth: 185,
                      enName: 'Concurrent',
                      cnName: '在线用户',
                      rainbowKey: 'Pc Metrics Online Users',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },
                  ]
                }
              }
            },
            {
              name: 'DataDownloadTableCo',
              className: 'margin-t-20',
              type: 'view',
              style: {},
              props: {
                config: {
                  titleEn: 'Retention Overall Performance',
                  titleCn: '留存整体表现',
                  isHaveDiff: false,
                  showStatistic: ['avg'],
                  formatType: 'playtime',
                  slotConfig: {
                    isShowValueType: false,
                    isShowMetricsSettings: false,
                    isShowProgressBar: false,
                    isShowdownloadConfig: false,
                  },
                  api: {
                    tableApi: '/api/v1/dashboard/realtime/overall/d237',
                    tableDownloadApi: '/api/v1/dashboard/realtime/overall/d237/download',
                  },
                  componentMetrics: [
                    {
                      metricKey: 'd2',
                      reqMetricKey: 'd2',
                      enPercentWidth: 185,
                      cnPercentWidth: 185,
                      enWidth: 185,
                      cnWidth: 185,
                      enName: 'D1(T-1)',
                      cnName: '新进次留(T-1)',
                      rainbowKey: 'Pc Metrics D1(T-1)',
                      type: 'percent',
                      decimal: 2,
                      percentDecimals: 1,
                    },
                    {
                      metricKey: 'd3',
                      reqMetricKey: 'd3',
                      enPercentWidth: 185,
                      cnPercentWidth: 185,
                      enWidth: 185,
                      cnWidth: 185,
                      enName: 'D2(T-2)',
                      cnName: '新进2留(T-2)',
                      rainbowKey: 'Pc Metrics D2(T-2)',
                      type: 'percent',
                      decimal: 2,
                      percentDecimals: 1,
                    },
                    {
                      metricKey: 'd7',
                      reqMetricKey: 'd7',
                      enPercentWidth: 185,
                      cnPercentWidth: 185,
                      enWidth: 185,
                      cnWidth: 185,
                      enName: 'D7(T-7)',
                      cnName: '新进7留(T-7)',
                      rainbowKey: 'Pc Metrics D7(T-7)',
                      type: 'percent',
                      decimal: 2,
                      percentDecimals: 1,
                    },
                  ]
                }
              }
            },
          ]
        },
      ],
    },
  ]
};

